import { defineStore  } from 'pinia'
import httpService from '@/utils/httpService'
import { URL } from '@/constants/urls'

export const usePrintStore = defineStore('print', {
  state: () => ({
  }),

  getters : {},
  
  actions: {
    print(content){
      httpService.post(URL.PRINT_RECEIPT, {content})
    },
  },
});